// Waitlist signups captured from the Coming Soon holding page. Documents
// are written anonymously (no auth required) — Firestore rules allow create
// only with a well-formed email payload, no read access from clients.

import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

const WAITLIST_COLLECTION = 'waitlistSignups';

export interface WaitlistEntry {
  email: string;
  source: string;
  createdAt: ReturnType<typeof serverTimestamp>;
  userAgent?: string;
  referrer?: string;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}

export async function addToWaitlist(
  email: string,
  source = 'coming-soon',
): Promise<void> {
  const trimmed = email.trim().toLowerCase();
  if (!isValidEmail(trimmed)) {
    throw new Error('Please enter a valid email address.');
  }
  // Build the entry incrementally so we never send undefined fields —
  // Firestore rejects them ("Unsupported field value: undefined").
  const entry: Record<string, unknown> = {
    email: trimmed,
    source,
    createdAt: serverTimestamp(),
  };
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    entry.userAgent = navigator.userAgent;
  }
  if (typeof document !== 'undefined' && document.referrer) {
    entry.referrer = document.referrer;
  }
  await addDoc(collection(db, WAITLIST_COLLECTION), entry);
}
